import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useSuspenseQuery } from '@tanstack/react-query'
import BusTripDetails from '@/components/make-booking/trip-details'
import useStepMutation from '@/hooks/useStepMutation'
import { BOOKING_STEPS } from '@/utils/constant'
import ModalLeaveBooking from '@/components/ui/ModalLeaveBooking'
import { getBookingQueryOptions } from '@/queries/query'

export const Route = createFileRoute('/make-booking/$id/trip-details')({
  component: RouterComponent,
})

function RouterComponent() {
  const isAuthenticated = Route.useRouteContext({
    select: (s) => s.authContext.isAuthenticated,
  })
  const bookingId = Route.useParams({
    select: (params) => params.id,
  })
  const { update } = useStepMutation()
  const {
    data: {
      data: { booking },
    },
  } = useSuspenseQuery(getBookingQueryOptions(bookingId))

  useEffect(() => {
    update.mutate({
      id: bookingId,
      step: BOOKING_STEPS.STEP_TRIP_DETAILS,
      type: 'booking',
    })
  }, [])

  return (
    <>
      <BusTripDetails bookingId={bookingId} />
      <Outlet />
      <ModalLeaveBooking
        isAuthenticated={isAuthenticated}
        disabledBlock={!!booking.parent}
      />
    </>
  )
}
